module.exports = __webpack_public_path__ + "img/ic-mode-visibility.13a5996c.svg";